import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from './Icon';
import styles from './SearchBar.module.scss';

type SearchBarProps = {
  readonly placeholder?: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly debounceMs?: number;
};

export function SearchBar({ placeholder = 'Search...', value, onChange, debounceMs = 300 }: SearchBarProps) {
  const { t } = useTranslation();
  const [local, setLocal] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  function handleChange(next: string) {
    setLocal(next);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => onChange(next), debounceMs);
  }

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    [],
  );

  return (
    <div className={styles.wrapper}>
      <span className={styles.icon}>
        <Icon name="search" size={16} />
      </span>
      <input
        className={styles.input}
        type="text"
        value={local}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder === 'Search...' ? t('clients.searchGeneric') : placeholder}
      />
    </div>
  );
}
